import { render, staticRenderFns } from "./ModalAddCategory.vue?vue&type=template&id=5545167f&scoped=true&"
import script from "./ModalAddCategory.vue?vue&type=script&lang=js&"
export * from "./ModalAddCategory.vue?vue&type=script&lang=js&"
import style0 from "./ModalAddCategory.vue?vue&type=style&index=0&id=5545167f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5545167f",
  null
  
)

export default component.exports